import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import ReactPlayer from 'react-player/youtube';
import EncuestaRespond from '../Formularios/EncuestaRespond';

const server = process.env.REACT_APP_SERVER;
function ProtocoloContenido(props) {
    const { info, regional, encuesta, subVista } = props;
    const [tipo, setTipo] = useState('');
    const [contenido, setContenido] = useState([]);
    const [pagina, setPagina] = useState(0);
    const [pag, setPag] = useState(1);
    const [play, setPlay] = useState(false);
    const eventosVideo = (datos) => {
        console.log(datos);
    }
    useEffect(() => {
        setContenido([]);
        var dato = info
        delete dato.MENU
        delete dato.VERSIONES
        if (dato.CONTENIDO === undefined) {
            fetch(`${server}/protocolos/getContenidoProtocolo`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ info: dato, regional })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data.ok);
                    if (data.ok) {
                        if (data.ok.length > 0) {
                            setTipo(data.ok[0].TIPO);
                            setPagina(data.ok.length);
                            setContenido(data.ok);
                        }
                    } else {
                        MsgUtils.msgError(data.error)
                    }
                })
                .catch(err => MsgUtils.msgError(err));
        } else {
            console.log("entor ", dato.CONTENIDO)
            if (dato.CONTENIDO.length != 0) {
                setTipo(dato.CONTENIDO[0].TIPO);
                setPagina(dato.CONTENIDO.length);
                setContenido(dato.CONTENIDO);
                if (dato.CONTENIDO[0].TIPO == 'VID') {
                    var video = document.getElementsByTagName('video')[0];
                    console.log(video);
                    if(video!=undefined){
                    var sources = video.getElementsByTagName('source');
                    sources[0].src = `${server}/sqlComun/videos/${dato.CONTENIDO[0].URL}.mp4`;
                    video.load();
                    }
                }
            } else {
                setTipo('null')
            }
        }
    }, [info, subVista])
    return (
        <>
            {tipo === "IMG" && contenido.length > 1 &&
                <div>
                    <div className='container-fluid bg-dark bg-gradient'>
                        <div className='row row-cols-3 g-1'>
                            <div className='col text-center m-0 p-0' style={{ width: '15%' }}>
                                <button className='btn btn-sm text-light m-0 p-0' data-bs-target="#carouselExampleControls" data-bs-slide="prev"
                                    onClick={() => { pag === 1 ? setPag(pagina) : setPag(pag - 1) }}>
                                    <i className="bi bi-arrow-left-circle-fill fs-2" ></i>
                                </button>
                            </div>
                            <div className='col my-auto text-light text-center fs-4' style={{ width: '70%' }}>
                                Imagen {pag}/{contenido.length}
                            </div>
                            <div className='col text-center' style={{ width: '15%' }}>
                                <button className='btn btn-sm text-light m-0 p-0' data-bs-target="#carouselExampleControls" data-bs-slide="next"
                                    onClick={() => { pag === pagina ? setPag(1) : setPag(pag + 1) }}>
                                    <i className="bi bi-arrow-right-circle-fill fs-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel" data-bs-touch="false" data-bs-interval="false">
                        <div className="carousel-inner">
                            {contenido.map((item, index) => {
                                return (
                                    <div className={index == 0 ? `carousel-item active` : 'carousel-item'} key={index}>
                                        <img src={`${server}/imagenes/${item.URL}`} className="d-block w-100" />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            }
            {tipo === 'IMG' && contenido.length == 1 &&
                <div className='container-fluid '>
                    <img src={`${server}/imagenes/${contenido[0].URL}`} className="d-block w-100" />
                </div>
            }
            {tipo === 'VID' && contenido.length != 0 &&
                <div className='card-body m-0 p-0'>
                    <div className='container-fluid p-2 videoShow'>
                        <video controls className='w-100' >
                            <source src={`${server}/sqlComun/videos/${contenido[0].URL}.mp4`} type="video/mp4" />
                        </video>
                        {false && <ReactPlayer url={contenido[0].URL + '?showinfo=0&controls=0'} width='100%' controls={false} playing={play}
                            config={{ youtube: { playerVars: { disablekb: 1, showinfo: 1 } } }}
                            onClickPreview={eventosVideo} style={{ pointerEvents: 'none' }}
                        />}
                        {false && <button className='btn btn-sm btn-success w-100 text-center'
                            style={{ fontSize: '35px' }}
                            onClick={() => setPlay(!play)}>
                            <i className="fa-solid fa-play "></i>
                        </button>}
                        {false && <button className='btn btn-sm btn-success w-100 text-center'
                            style={{ fontSize: '35px' }}
                            onClick={() => setPlay(!play)}>
                            <i className="fa-solid fa-pause "></i>
                        </button>}
                    </div>
                </div>
            }
            {tipo=='PDF'&&contenido.length!=0&&
                <div className='card-body m-0 p-0'>
                    <iframe src={`${server}/imagenes/${contenido[0].URL}`} style={{width:'100%',height:'80vh'}} />
                </div>
            }
        </>
    )
}

export default ProtocoloContenido
